export enum AuditTrailUserActionType {
  AUDIT_TRAIL_SEARCH = 'actions/audittrail/events/SEARCH',
}

export const resourceName = '//audittrail';
